import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Fotter';
import CarvingTilsRoom from '../../assets/carving-tils-room.avif';
import CarvingTilsRoom1 from '../../assets/carving-tils-room-1.png';
import CarvingTils1 from '../../assets/carving-tils-1.jpg';
import CarvingTils2 from '../../assets/carving-tils-2.jpeg';
import CarvingTils3 from '../../assets/carving-tils-3.jpeg';
import CarvingTils4 from '../../assets/carving-tils-4.jpeg';
import glossy from '../../assets/elevetionglossy/glossy.jpg';
import glossy1 from '../../assets/elevetionglossy/glossy1.jpg';
import glossy2 from '../../assets/elevetionglossy/glossy2.jpg';
import glossy3 from '../../assets/elevetionglossy/glossy3.jpg';
import glossy4 from '../../assets/elevetionglossy/glossy4.jpg';
import glossy5 from '../../assets/elevetionglossy/glossy5.jpg';
import glossy6 from '../../assets/elevetionglossy/glossy6.jpg';
import glossy7 from '../../assets/elevetionglossy/glossy7.jpg';
import matt from '../../assets/elevetionmatt/matt.jpg';
import matt1 from '../../assets/elevetionmatt/matt1.jpg';
import matt2 from '../../assets/elevetionmatt/matt2.jpg';
import matt3 from '../../assets/elevetionmatt/matt3.jpg';
import matt4 from '../../assets/elevetionmatt/matt4.jpg';
import matt5 from '../../assets/elevetionmatt/matt5.jpg';
import matt6 from '../../assets/elevetionmatt/matt6.jpg';
import matt7 from '../../assets/elevetionmatt/matt7.jpg';
import carving from '../../assets/elevetioncarving/carving.jpg';
import carving1 from '../../assets/elevetioncarving/carving1.jpg';
import carving2 from '../../assets/elevetioncarving/carving2.jpg';
import carving3 from '../../assets/elevetioncarving/carving3.jpg';
import carving4 from '../../assets/elevetioncarving/carving4.jpg';
import carving5 from '../../assets/elevetioncarving/carving5.jpg';
import carving6 from '../../assets/elevetioncarving/carving6.jpg';
import carving7 from '../../assets/elevetioncarving/carving7.jpg';
import cr1 from '../../assets/elevetioncarving/cr1.jpg';
import cr2 from '../../assets/elevetioncarving/cr2.jpg';
import cr3 from '../../assets/elevetioncarving/cr3.jpg';
import cr4 from '../../assets/elevetioncarving/cr4.jpg';
import cr5 from '../../assets/elevetioncarving/cr5.jpg';
import cr6 from '../../assets/elevetioncarving/cr6.jpg';
import cr7 from '../../assets/elevetioncarving/cr7.jpg';
import cr8 from '../../assets/elevetioncarving/cr8.jpg';
import gl1 from '../../assets/elevetionglossy/gl1.jpg';
import gl2 from '../../assets/elevetionglossy/gl2.jpg';
import gl3 from '../../assets/elevetionglossy/gl3.jpg';
import gl4 from '../../assets/elevetionglossy/gl4.jpg';
import gl5 from '../../assets/elevetionglossy/gl5.jpg';
import gl7 from '../../assets/elevetionglossy/gl7.jpg';
import gl8 from '../../assets/elevetionglossy/gl8.jpg';
import mt4 from '../../assets/elevetionmatt/mt4.jpg';
import mt5 from '../../assets/elevetionmatt/mt5.jpg';
import mt6 from '../../assets/elevetionmatt/mt6.jpg';
import mt7 from '../../assets/elevetionmatt/mt7.jpg';
import adanaAsh from '../../assets/Adana Ash.webp';


// Placeholder images for High Gloss tiles (replace with actual high gloss tile image assets)



const Elevation = () => {
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);

  // State for filters
  const [selectedSize, setSelectedSize] = useState("16x16 inch"); // Default size
  const [selectedFinish, setSelectedFinish] = useState("GLOSSY");

  // Available Finishes
  const availableFinishes = [
    'GLOSSY', 'CARVING', 'MATT'
  ];
  // Function to open modal with selected image
  const openModal = (image, title, viewMode = 'single', roomScene = null) => {
    setIsImageLoading(true);
    setSelectedImage({ src: image, title, viewMode, roomScene });
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setIsImageLoading(true);
  };

  // Handle outside click to close modal
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Handle keyboard accessibility and prevent body scroll
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  // Glossy Images for Glossy Finish
  const glossCollections = [
    { src: glossy, title: 'EX-114 ARMANI BROWN', roomScene: gl1 },
    { src: glossy1, title: 'EX-115 ARMANI CREMA', roomScene: gl2 },
    { src: glossy2, title: 'EX-116 ARMANI NATURAL', roomScene: gl3 },
    { src: glossy3, title: 'EX-117 ARMANI WHITE', roomScene: gl4 },
    { src: glossy4, title: 'EX-132 BOTTOCHINO', roomScene: gl5 },
    { src: glossy5, title: 'EX-137 BRECCIA VATICAN BR' },
    { src: glossy6, title: 'EX-140 BRONZE DYNA GREY', roomScene: gl7 },
    { src: glossy7, title: 'EX-141 BRONZE DYNA', roomScene: gl8 },
  ];

  // Matt Images for Matt Finish
  const mattImages = [
    { src: matt, title: 'BEND GRIS' },
    { src: matt1, title: 'BEND NERO' },
    { src: matt2, title: 'BEND WHITE' },
    { src: matt3, title: 'BETON ASH', roomScene: adanaAsh },
    { src: matt4, title: 'BETON BEIGE', roomScene: mt4 },
    { src: matt5, title: 'BETON BROWN', roomScene: mt5 },
    { src: matt6, title: 'BETON CREMA' },
    { src: matt7, title: 'BETON DECOR 1' },
  ];

  // Carving Images for Carving Finish
  const carvingImages = [
    { src: carving, title: 'CAMPUS BROWN', roomScene: cr1 },
    { src: carving1, title: 'CAMPUS CREMA', roomScene: cr2 },
    { src: carving2, title: 'CAMPUS NERO', roomScene: cr3 },
    { src: carving3, title: 'CENBERRA PISTA', roomScene: cr4 },
    { src: carving4, title: 'COSTONE BEIGE', roomScene: cr5 },
    { src: carving5, title: 'COSTONE BIANCO', roomScene: cr6 },
    { src: carving6, title: 'COSTONE CREMA', roomScene: cr7 },
    { src: carving7, title: 'COSTONE GREEN', roomScene: cr8 },
  ];



  const glossCategory = {
    fullName: "Elevation Finish Tiles",
    description:
      "Premium Elevation finish tiles offering a reflective, luxurious surface that enhances light and space in any interior.",
    features: ["Water Absorption < 0.5%", "Highly Reflective Surface", "Stain Resistant", "Low Maintenance"],
    sizes: ["16x16 inch", "20x20 inch"],
  };

  // Filter collections based on selected size and finish


  return (
    <div className="w-full overflow-hidden">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] bg-gradient-to-r from-gray-900 via-gray-800 to-orange-900">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${CarvingTilsRoom})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 drop-shadow-2xl">
              Elevation Collection
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light">
              {glossCategory.fullName}
            </p>
            <div className="mt-4 sm:mt-6 w-24 sm:w-28 lg:w-32 h-1 bg-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Product Info Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Premium <span className="text-orange-600">Elevation Tiles</span>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto mb-6 sm:mb-8 leading-relaxed">
              {glossCategory.description} Our Elevation tiles combine advanced technology with a mirror-like finish to create stunning, reflective spaces.
            </p>
            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
              {glossCategory.features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="bg-orange-600 text-white text-lg sm:text-xl md:text-2xl w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    ✓
                  </div>
                  <p className="text-gray-800 font-semibold text-sm sm:text-base md:text-lg">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEW FILTER SECTION */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-1">
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 md:p-12 shadow-xl border border-gray-100">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">

              {/* Size Selection */}
              <div className="lg:w-1/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Size</h3>
                <div className="flex flex-col gap-4">
                  {glossCategory.sizes.map((size) => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(selectedSize === size ? null : size)}
                      className={`
                        w-full py-4 px-6 rounded-xl text-lg font-bold transition-all duration-300 border
                        ${selectedSize === size
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {size.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>

              {/* Vertical Divider (Visible on Large Screens) */}
              <div className="hidden lg:block w-px bg-gray-200 my-2"></div>

              {/* Horizontal Divider (Visible on Small Screens) */}
              <div className="block lg:hidden h-px w-full bg-gray-200"></div>

              {/* Finish Selection */}
              <div className="lg:w-2/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Finish</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
                  {availableFinishes.map((finish) => (
                    <button
                      key={finish}
                      onClick={() => setSelectedFinish(selectedFinish === finish ? null : finish)}
                      className={`
                        py-3 px-2 sm:px-4 rounded-xl text-xs sm:text-sm font-bold transition-all duration-300 h-16 sm:h-20 flex items-center justify-center text-center border
                        ${selectedFinish === finish
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {finish}
                    </button>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Results Section */}
      {/* Matt Collection Grid */}
      {selectedFinish === 'MATT' && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Matt Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant and extensive range of our Matt finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {mattImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">{selectedSize ? `Size: ${selectedSize}` : 'Matt Collection'}</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Matt Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Carving Collection Grid */}
      {selectedFinish === 'CARVING' && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Carving Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant and extensive range of our Elevation finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {carvingImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">{selectedSize ? `Size: ${selectedSize}` : 'Carving Collection'}</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Elevation Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {selectedFinish === 'GLOSSY' && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Glossy Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant and extensive range of our Glossy finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {glossCollections.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">{selectedSize ? `Size: ${selectedSize}` : 'Glossy Collection'}</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Glossy Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Available Sizes Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Available <span className="text-orange-600">Sizes</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto">
              {glossCategory.sizes.map((size, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-100 to-orange-200 text-orange-800 font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl text-center shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1"
                >
                  <div className="text-lg sm:text-xl md:text-2xl mb-1 sm:mb-2">📏</div>
                  <div className="text-sm sm:text-base md:text-lg">{size}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb reinforcement-learning-4">
              Technical <span className="text-orange-600">Specifications</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-2xl sm:max-w-4xl lg:max-w-6xl mx-auto">
            {[
              { icon: "💧", title: "Water Absorption", desc: "Less than 0.5% as per IS 15622" },
              { icon: "💪", title: "Breaking Strength", desc: "Minimum 1800N as per IS 15622" },
              { icon: "✨", title: "Reflective Surface", desc: "Elevation finish for enhanced light reflection" },
            ].map((spec, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-xl shadow-lg">
                <div className="text-orange-600 text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 text-center">{spec.icon}</div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 text-center">{spec.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center">{spec.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-600 to-orange-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            Transform Your Space Today
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-100 mb-6 sm:mb-8 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed">
            Contact our design experts to find the perfect Elevation finish tiles for your project. Get personalized recommendations and professional installation support.
          </p>
        </div>
      </section>

      {/* Modal for Image Zoom */}
      {/* Modal for Image Zoom */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-2 sm:p-4"
          onClick={handleOutsideClick}
        >
          <div className={`relative w-full mx-auto outline-none ${selectedImage.viewMode === 'detail' ? 'max-w-7xl' : 'max-w-5xl'}`}>

            {selectedImage.viewMode === 'detail' ? (
              // Detailed Product Modal
              <div className="bg-white rounded-xl overflow-hidden shadow-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="bg-orange-600 p-4 sm:p-6 text-center relative">
                  <h2 className="text-white text-xl sm:text-3xl font-bold uppercase tracking-wider">{selectedImage.title}</h2>
                  <button
                    onClick={closeModal}
                    className="absolute top-1/2 -translate-y-1/2 right-4 sm:right-6 text-white hover:text-orange-200 transition-colors text-2xl font-bold"
                  >
                    ✕
                  </button>
                </div>

                <div className="flex flex-col lg:flex-row">
                  {/* Left: Room Scene - Only show if roomScene exists */}
                  {selectedImage.roomScene && (
                    <div className="lg:w-1/2 p-6 bg-gray-50 flex items-center justify-center">
                      <img
                        src={selectedImage.roomScene}
                        alt="Room Scene"
                        className="w-full h-full rounded-lg shadow-md object-cover max-h-[500px]"
                      />
                    </div>
                  )}

                  {/* Right: Faces & Info - Full width if no roomScene */}
                  <div className={`${selectedImage.roomScene ? 'lg:w-1/2' : 'w-full'} p-6 flex flex-col`}>
                    {/* Faces Grid */}
                    <div className="grid grid-cols-4 gap-4 mb-8">
                      {[1, 2, 3, 4].map((_, i) => (
                        <div key={i} className="aspect-[2/3] rounded-lg overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                          <img src={selectedImage.src} alt={`Face ${i + 1}`} className="w-full h-full object-cover" />
                        </div>
                      ))}
                    </div>

                    {/* Product Info */}
                    <div>
                      <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                        Elegant {selectedFinish ? selectedFinish.toLowerCase() : 'finish'} texture with subtle design for luxurious spaces.
                        Perfect for both residential and commercial applications.
                      </p>

                      <div className="flex flex-wrap gap-3 mb-6">
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Size: {selectedSize}
                        </span>
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Finish: {selectedFinish ? selectedFinish : 'Standard'}
                        </span>
                      </div>

                      <div className="space-y-2">
                        {['High Strength', 'Water Resistant', 'Stain Resistant', 'Easy Maintenance'].map((feat, i) => (
                          <div key={i} className="flex items-center text-gray-700">
                            <span className="text-orange-600 mr-2">✓</span>
                            {feat}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // Simple Zoom Modal
              <div className="relative flex flex-col items-center justify-center">
                {isImageLoading && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 sm:w-14 lg:w-16 h-12 sm:h-14 lg:h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                )}
                <img
                  src={selectedImage.src}
                  alt={`Zoomed view of ${selectedImage.title}`}
                  className="w-full h-auto max-h-[90vh] object-contain rounded-lg shadow-2xl"
                  onLoad={() => setIsImageLoading(false)}
                />
                <button
                  onClick={closeModal}
                  className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white text-black rounded-full p-2 sm:p-3 hover:bg-gray-200 transition-all duration-300 text-base sm:text-lg lg:text-xl font-bold shadow-lg"
                >
                  ✕
                </button>
                {selectedImage && !isImageLoading && (
                  <div className="absolute bottom-2 sm:bottom-3 left-2 sm:left-4 bg-black/70 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-lg">
                    <h3 className="text-sm sm:text-base md:text-lg font-bold">{selectedImage.title}</h3>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Elevation;